import { useBranding } from "../../branding/BrandingProvider";
import { SrOnly } from "../SrOnly";

export const MainAppLogo = () => {
  const { logo } = useBranding();
  const Logo = logo.Component;
  return (
    <>
      <Logo />
      <SrOnly>{logo.alt}</SrOnly>
    </>
  );
};
